import { render, staticRenderFns } from "./GeneralEffects.vue?vue&type=template&id=5fca361c&scoped=true&"
import script from "./GeneralEffects.vue?vue&type=script&lang=js&"
export * from "./GeneralEffects.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEffects.vue?vue&type=style&index=0&id=5fca361c&scoped=true&lang=scss&"
import style1 from "./GeneralEffects.vue?vue&type=style&index=1&id=5fca361c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca361c",
  null
  
)

export default component.exports